import { useTranslation } from "react-i18next";
import ReCAPTCHA from "react-google-recaptcha";
import { GOOGLE_CAPTCHA_KEY } from "../../../constants";
import { SignupTextInput } from "../../../parts/inputs/SignupTextInput";
import SvgIcon from "../../../parts/SvgIcon";
import StepHeading from "./StepHeading";

// Step 1 — account creation. Fields here are submitted (multipart) to
// register-coach at the Building App step. reCAPTCHA + TOS gate the step.
const StepProfile = ({
  current,
  state,
  onInputChange,
  onSelectFile,
  onAvatarChange,
  onToggleTOS,
  onCaptcha,
}) => {
  const { t } = useTranslation("auth");
  const { errors = {} } = state;

  return (
    <div className="step-body step-profile">
      <StepHeading
        current={current}
        title={t("onboardingWizard.profile.title")}
        subtitle={t("onboardingWizard.profile.subtitle")}
      />

      {/* biome-ignore lint/a11y/useKeyWithClickEvents: matches the avatar control used across the onboarding flow. */}
      {/* biome-ignore lint/a11y/noStaticElementInteractions: matches the avatar control used across the onboarding flow. */}
      <div className="avatar-wrapper" onClick={(e) => onSelectFile(e, true)}>
        <div className="upload-icon-wrapper">
          <div className="upload-icon" />
        </div>
        {state.avatar !== "" && (
          // biome-ignore lint/a11y/useKeyWithClickEvents: nested avatar remove control, matches existing flow.
          // biome-ignore lint/a11y/noStaticElementInteractions: nested avatar remove control, matches existing flow.
          <div
            className="upload-icon-wrapper remove-wrapper"
            onClick={(e) => onSelectFile(e, false)}
          >
            <div className="remove-icon" />
          </div>
        )}
        {state.avatar === "" ? (
          <SvgIcon src="/img/new-icons/vuesax-linear-user.svg" />
        ) : (
          <img id="avatar" className="avatar" alt="avatar" src={""} />
        )}
      </div>
      <input
        id="avatar-input"
        className="hidden"
        type="file"
        // Omitted (rather than left empty) when no file is chosen — an
        // untouched file input still submits an empty file part, which the
        // upload middleware treats as a real avatar upload.
        name={state.avatar === "" ? undefined : "avatar"}
        accept="image/*"
        onChange={onAvatarChange}
      />

      <div className="field-grid">
        <SignupTextInput
          label={t("signupCoach.firstName")}
          name="first_name"
          required
          type="text"
          placeholder={t("onboardingWizard.profile.enterFirstName")}
          defaultValue={state.first_name}
          onChange={onInputChange}
          hasError={!!errors.first_name}
          error={errors.first_name}
        />
        <SignupTextInput
          label={t("signupCoach.lastName")}
          name="last_name"
          required
          type="text"
          placeholder={t("onboardingWizard.profile.enterLastName")}
          defaultValue={state.last_name}
          onChange={onInputChange}
          hasError={!!errors.last_name}
          error={errors.last_name}
        />
        <SignupTextInput
          label={t("signupCoach.email")}
          name="email"
          required
          type="email"
          placeholder={t("onboardingWizard.profile.enterEmail")}
          defaultValue={state.email}
          onChange={onInputChange}
          hasError={!!errors.email}
          error={errors.email}
        />
        <SignupTextInput
          label={t("signupCoach.businessName")}
          name="businessName"
          type="text"
          placeholder={t("onboardingWizard.profile.enterBusinessName")}
          defaultValue={state.businessName}
          onChange={onInputChange}
        />
        <SignupTextInput
          label={t("signupCoach.password")}
          name="password"
          required
          type="password"
          placeholder={t("onboardingWizard.profile.createPassword")}
          defaultValue={state.password}
          onChange={onInputChange}
          hasError={!!errors.password}
          error={errors.password}
        />
        <SignupTextInput
          label={t("signupCoach.confirmPassword")}
          name="confirmPassword"
          required
          type="password"
          placeholder={t("onboardingWizard.profile.confirmPassword")}
          defaultValue={state.confirmPassword}
          onChange={onInputChange}
          hasError={!!errors.confirmPassword}
          error={errors.confirmPassword}
        />
      </div>

      <div className="relative tos-row">
        <label className="checkbox-input" htmlFor="agreeTOS-checkbox">
          <input
            id="agreeTOS-checkbox"
            type="checkbox"
            name="agreeTOS"
            onChange={onToggleTOS}
            checked={state.agreeTOS}
            data-has-error={!!errors.agreeTOS}
          />
          {t("signupCoach.agreeTerms")}{" "}
          <a
            href="https://mystrengthbook.com/terms-of-use/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("signupCoach.termsOfUse")}
          </a>
        </label>
        {errors.agreeTOS ? <p className="error">{errors.agreeTOS}</p> : null}
      </div>

      <div className="relative recaptcha-row">
        <ReCAPTCHA
          sitekey={GOOGLE_CAPTCHA_KEY}
          onChange={onCaptcha}
          theme={state.recaptchaTheme}
          size="normal"
        />
        {errors.recaptcha ? <p className="error">{errors.recaptcha}</p> : null}
      </div>
    </div>
  );
};

export default StepProfile;
